<template>
    <div class="grid grid__dot-cols text-columns-auto-with-images dot-cols dot-cols__mixed dot-cols__col-3">
        <!-- <pre v-if="content" v-text="content"></pre> -->
        <div class="grid--row dot-cols--row">
            <div class="grid--col dot-cols--col dot-cols--col__text"
                    v-html="content.text">
            </div>
            <div class="grid--col dot-cols--col dot-cols--col__images">
                <img v-for="(image, idx) in content.images"
                        class="text-columns-auto-with-images--img"
                        :src="image.url"
                        :alt="image.alt">
            </div>
        </div>
    </div>
</template>

<script>
    import cmsPlugin from 'vue/mixins/cms/cms-plugin';
    import bemMixin from 'vue/mixins/bem';


    export default {
        mixins: [
            bemMixin('text-columns-auto-with-images'),
            cmsPlugin,
        ],
    };
</script>



// WEBPACK FOOTER //
// index.vue?156350af